<template>
  <div
    class="fixed left-0 top-0 bg-overlay w-full h-full z-65001"
  >
    <div
      class="building-tooltip bg-white rounded-lg w-96 relative p-4 transform left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
    >
      <div class="flex flex-col">
        <span class="text-3xl w-full leading-none font-oswald font-light uppercase">
          {{ building.name }}
        </span>

        <div class="mt-5 flex flex-row">
          <BuildingLevelDisplay
            :class="{
              'w-1/3': building.isEvent,
              'w-full': !building.isEvent,
            }"
            :building-id="buildingId"
            @changeLevel="changeLevel"
          />

          <BuildingEraDisplay
            v-if="building.isEvent"
            class="w-2/3 text-right"
            :building-era="building.era"
            @changeEra="changeEra"
          />
        </div>

        <HappinessDisplay
          v-if="hasHappiness"
          :building-id="buildingId"
          class="mt-4"
        />

        <EffectsDisplay
          :building-id="buildingId"
          class="mt-6"
        />
      </div>

      <div class="text-right mt-4 pt-4 border-t border-roc-gray">
        <button
          class="rounded bg-gray-roc hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="hideTooltip"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BuildingEraDisplay from '@/components/Grid/PlacedBuilding/BuildingEraDisplay.vue';
import BuildingLevelDisplay from '@/components/Grid/PlacedBuilding/BuildingLevelDisplay.vue';
import HappinessDisplay from '@/components/Grid/PlacedBuilding/HappinessDisplay.vue';
import {computed, readonly} from 'vue';
import EffectsDisplay from '@/components/Grid/PlacedBuilding/EffectsDisplay.vue';
import {useMuseumStore} from '@/roc/stores/MuseumStore';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import {useLayoutStore} from '@/roc/stores/LayoutStore';

export default {
  components: {
    EffectsDisplay,
    HappinessDisplay,
    BuildingLevelDisplay,
    BuildingEraDisplay
  },
  props: {
    buildingId: {
      type: String,
      required: true
    },
  },
  emits: ['hide', 'museum', 'level', 'era'],
  setup (props, context) {
    const museumStore = useMuseumStore();
    const appStore = useApplicationStore();
    const lytStore = useLayoutStore();
    
    const thisBuilding = computed(() => {
      return lytStore.buildings[props.buildingId];
    });

    return {
      building: readonly(thisBuilding),

      activeArtifacts: computed(() => {
        return "(" + museumStore.activeArtifactCount + "/" + museumStore.totalArtifactCount + ")";
      }),
      cityHallCulture: computed(() => {
        return museumStore.cultureBonus.value;
      }),
      hasHappiness: computed(() => {
        return thisBuilding.value.hasHappiness;
      }),
      editable: computed(() => {
        return appStore.editable;
      }),

      hideTooltip() {
        context.emit('hide');
      },
      changeLevel(newLevel) {
        context.emit('level', newLevel);
      },
      changeEra(newEraId) {
        context.emit('era', newEraId);
      }
    };
  }
};
</script>
